import { withStyles } from "@material-ui/core";
import React from "react";
import Header from "./Header";

const styles = (theme) => ({
  message: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    display: "flex",
    flexDirection: "column"
  }
});

const getShipmentCellError = (shipmentsErrors) => {
  let uniqueError = [];
  shipmentsErrors.forEach((errorObj) => {
    if (!errorObj) {
      return;
    }
    uniqueError = [
      ...new Set([...uniqueError, ...Object.values(errorObj).filter(Boolean)])
    ];
  });
  return uniqueError;
};

const GridError = ({ shipmentsErrors, classes }) => {
  const errorList = getShipmentCellError(shipmentsErrors)
  if (errorList.length === 0) {
    return null;
  }
  return (
    <>
      <Header label="Error" variant="error" />
      <div className={classes.message}>
        {errorList.map((error, index) => (
          <span key={`error-${index}`}>{error}</span>
        ))}
      </div>
    </>
  );
};

export default withStyles(styles)(GridError);
